import type { TAccessControlRules } from '@frontend/components/agromarket/core/access-control'
import { EAccessControlValue } from '@frontend/components/agromarket/core/access-control'
import type { TFinancingAccessControlContext } from './types'

export const FINANCING_ACCESS_CONTROL_LIST = {
  financing: {
    popup: {
      preApprovedLoanBanner: ({ auth, isLoanApproved }) => {
        return isLoanApproved === true && auth.isAuthenticated ? EAccessControlValue.VISIBLE : EAccessControlValue.HIDDEN
      },
      productHelper: ({ auth, isLoanApproved }) => {
        if (!auth.isAuthenticated) return EAccessControlValue.VISIBLE

        return auth.isAuthenticated && isLoanApproved === false ? EAccessControlValue.VISIBLE : EAccessControlValue.HIDDEN
      },
    },
  },
} satisfies Readonly<TAccessControlRules<TFinancingAccessControlContext>>
